<template>
  <v-col cols="12" class="mt-auto">
    <v-row>
      <v-col cols="auto" class="ml-4">
        <v-img :src="$coreScores.getOverallImage(value)"></v-img>
      </v-col>
      <v-col>
        <div>
          <span
            class="text-h2"
            v-bind:style="{
              color: color
            }"
          >
            {{ value }}
          </span>
          <span class="subtitle-1 lighttext--text">
            of {{ coreCard.possible }}</span
          >
        </div>
        <div class="subtitle-1">
          This overall score is
          <span
            v-bind:style="{
              color: color
            }"
            >{{ $coreScores.getTitle(reverse) }}</span
          >
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "CoreCardOverall",
  props: {
    coreCard: { type: Object }
  },
  computed: {
    value() {
      return Math.round(this.coreCard.value);
    },
    reverse() {
      return this.$coreScores.reverseFormat(this.value);
    },
    color() {
      return this.$coreScores.getColor(this.reverse);
    }
  }
};
</script>
